module.exports = __webpack_public_path__ + "static/thpcwhiteelephantmummy1-e77631a646962ff0f88478b86f087d65.jpeg";